var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.trialStatus)?_c('v-chip',{attrs:{"data-e2e-id":("trial-status-chip-" + (_vm.kebab(_vm.trialStatus.text)))}},[_c(_vm.trialStatus.icon,{tag:"component"}),_c('b',{staticClass:"px-1"},[_vm._v(_vm._s(_vm.trialStatus.text))])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }